// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isKeyOf<T extends object>(targetObject: T, key: keyof any): key is keyof T {
  return key in targetObject;
}

export type StrictOmit<T, K extends keyof T> = Omit<T, K>;
